// extracted by mini-css-extract-plugin
export default {"searchAndSort":"pI3iLn5Rib"};